const statusUnmap = {
  activated: 'ACTIVE',
  deactivated: 'INACTIVE',
  'pending-invite': 'PENDING',
};

export function getUserNameByEmail(users = [], emailToFind = '') {
  const user = users.find((user) => user.email === emailToFind);

  return user
    ? `${user.firstName} ${user.lastName}`
    : '';
}

export function revertStatusText(status) {
  // eslint-disable-line class-methods-use-this
  return statusUnmap[status];
}

export function retrieveFirstLetter(name) {
  return name ? name[0].toUpperCase() : '';
}

export function getSafeFullName(user) {
  const safeFirstName = (user.firstName) || '';
  const safeLastName = (user.lastName) || '';
  const fullName = (safeFirstName)
    ? `${safeFirstName} ${safeLastName}`
    : safeLastName;

  return fullName;
}

export default {
  getUserNameByEmail,
  revertStatusText,
  retrieveFirstLetter,
  getSafeFullName,
};
